// extracted by mini-css-extract-plugin
module.exports = {"DroppableAreaOverlay":"DroppableArea_DroppableAreaOverlay__35hna"};